import React from 'react';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Alert, Spin } from 'antd';
import { t } from 'ttag';

export const URL_PROTOCOL_REGEXP = /^https?:\/\//;

interface Props {
  src: string;
  onLoad: () => void;
}

const Loader = ({ src, onLoad }: Props) => {
  if (typeof src === 'undefined' || !URL_PROTOCOL_REGEXP.test(src)) {
    return <Alert title={t`Failed to load image.`} type="error" showIcon />;
  }

  const img = new Image();
  img.src = src;
  img.onload = onLoad;

  return (
    <Spin
      style={{ display: 'flex', justifyContent: 'center' }}
      indicator={<Loading3QuartersOutlined style={{ fontSize: '24px', color: '#575757' }} spin />}
    />
  );
};

export default Loader;
